import { render, staticRenderFns } from "./CertificateUploadButton.vue?vue&type=template&id=1d399a21&scoped=true&"
import script from "./CertificateUploadButton.vue?vue&type=script&lang=js&"
export * from "./CertificateUploadButton.vue?vue&type=script&lang=js&"
import style0 from "./CertificateUploadButton.vue?vue&type=style&index=0&id=1d399a21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d399a21",
  null
  
)

export default component.exports